'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var channels = exports.channels = {
  title: 'Channels',
  description: 'Enjoy the best courses from Universities and Educational Organizations.',
  make_your_own: 'Or create your own channel and broadcast the content to the world.',
  schools_title: 'Universities',
  schools_description: 'Learn from the best Universities of the world and enhance your training in any skill, using MOOCs and free video courses.',
  schools_view_all: 'See all Universities',
  schools_create_title: 'Do you want to create your own University?',
  schools_create_description: 'Service available to certified educational organizations.',
  schools_create_cta: 'Make your reservation now!',
  organizations_title: 'Organizations',
  organizations_description: 'Find the best video content from companies, associations, and foundations, that share their knowledge to better the world.',
  organizations_view_all: 'See all Organizations',
  organizations_create_title: 'Create your own channel in Tutellus. It is free!',
  organizations_create_description: 'Service available for companies and brands.',
  organizations_create_cta: 'Make your reservation now!',
  courses_title: 'Courses',
  teachers_title: 'Teachers'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/channels.js
// module id = 713
// module chunks = 0